// pages/OAuthCallback.jsx
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'react-oauth2-code-pkce';
import { jwtDecode } from 'jwt-decode';

export default function OAuthCallback() {
  const { token, loginInProgress, error, tokenData, login } = useAuthContext(); // Ajout de login
  const navigate = useNavigate();
  const hasRedirected = useRef(false);
  const tokenExchangeAttempted = useRef(false);

  useEffect(() => {
    console.log("========== OAuthCallback MOUNTÉ ==========");
    console.log("URL actuelle:", window.location.href);
    console.log("Code dans l'URL:", window.location.search);
    console.log("Token:", token);
    console.log("TokenData:", tokenData);
    console.log("LoginInProgress:", loginInProgress);
    console.log("Error:", error);
    
    // Vérifier si nous avons un code dans l'URL mais pas encore de token
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    
    if (code && !token && !loginInProgress && !tokenExchangeAttempted.current) {
      console.log("Code trouvé dans l'URL mais pas de token - la bibliothèque devrait échanger automatiquement");
      console.log("Code:", code);
      tokenExchangeAttempted.current = true;
      
      // Si après 3 secondes toujours pas de token, forcer un appel à login()
      setTimeout(() => {
        if (!token && !hasRedirected.current) {
          console.log("Toujours pas de token après 3s, tentative de login() manuel");
          login();
        }
      }, 3000);
    }
    
    if (hasRedirected.current) return;
    
    if (error) {
      console.error("Erreur d'authentification:", error);
      hasRedirected.current = true;
      navigate('/login?error=auth_failed', { replace: true });
      return;
    }
    
    if (token && !loginInProgress) {
      try {
        console.log("Token reçu, tentative de décodage");
        
        // Essayer d'obtenir les rôles depuis tokenData ou en décodant le token
        let role = 'ROLE_CLIENT';
        
        if (tokenData && tokenData.roles) {
          console.log("Utilisation de tokenData:", tokenData);
          role = tokenData.roles[0] || 'ROLE_CLIENT';
        } else {
          try {
            const decoded = jwtDecode(token);
            console.log("Token décodé manuellement:", decoded);
            role = decoded.roles?.[0] || 'ROLE_CLIENT';
          } catch (decodeErr) {
            console.error("Erreur décodage JWT:", decodeErr);
          }
        }
        
        console.log("Rôle extrait:", role);
        
        const redirectMap = {
          'ROLE_ADMIN': '/admin',
          'ROLE_SUPERADMIN': '/superadmin',
          'ROLE_RH': '/rh',
          'ROLE_FINANCE': '/finance',
          'ROLE_OPERATEUR': '/operateur',
          'ROLE_CLIENT': '/client',
          'ROLE_ENTREPRISE': '/entreprise'
        };
        
        const targetPath = redirectMap[role] || '/client';
        console.log("Redirection vers:", targetPath);
        
        hasRedirected.current = true;
        navigate(targetPath, { replace: true });
        
      } catch (err) {
        console.error("Erreur lors du traitement du token:", err);
        hasRedirected.current = true;
        navigate('/login?error=token_invalid', { replace: true });
      }
    } else {
      console.log("En attente du token... (loginInProgress:", loginInProgress, ")");
    }
  }, [token, tokenData, loginInProgress, error, navigate, login]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-slate-50">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-900 mb-4"></div>
      <p className="text-slate-600 font-medium">
        {loginInProgress 
          ? 'Authentification en cours...' 
          : token 
            ? 'Redirection vers votre espace...' 
            : 'Échange du code d\'autorisation...'}
      </p>
      {error && (
        <p className="text-red-600 mt-4 text-sm">
          Erreur d'authentification: {error.message || 'Erreur inconnue'}
        </p>
      )}
      <p className="text-slate-400 text-xs mt-8">
        {window.location.search ? 'Code présent dans l\'URL' : 'Pas de code dans l\'URL'}
      </p>
    </div>
  );
}